export const WORDS = [
  ['adere', 'adj. II', 'slippery; sleek, smooth; fast, quick'],
  ['albie', 'adj. III', 'bright, resplendent, shining, shiny, brilliant'],
  ['arakh', 'n. 6for.sol.', 'a curved sword used by the Dothraki'],
  ['arlie', 'adj. III', 'new'],
  ['avero', 'n. 3lun.', 'grape'],
  ['beqes', 'n. 4sol.', 'sow, female pig'],
  ['bisir', 'dem.pron. 5aq.', 'this one, proximal, animate, for abstract or uncountable entitites'],
  ['bonir', 'dem.pron. 5aq.', 'that one, distal, animate, for abstract or uncountable entities'],
  ['botes', 'n. 4sol.', 'work'],
  ['dubys', 'n. 2sol.', 'sibling; cousin by father\'s brother or mother\'s sister, parallel cousin'],
  ['eglia', 'n. 1lun.', 'ancestor'],
  ['eglie', 'adj. III', 'high (physically, in status or quality), good, superior; late (temporally)'],
  ['egros', 'n. 3sol.', 'edge; blade; sword'],
  ['eleks', 'n. 3sol.', 'ear'],
  ['embar', 'n. 1aq.', 'sea, ocean'],
  ['endia', 'n. 1lun.', 'west, the west'],
  ['endie', 'adj. III', 'west, western'],
  ['epses', 'n. 4sol.', 'female goat, nanny goat'],
  ['galry', 'n. 2lun.', 'hammer, mallet'],
  ['gelte', 'n. 4lun.', 'helmet, helm'],
  ['genes', 'n. 4sol.', 'mouse, rat'],
  ['geron', 'n. 3ter.', 'path, walk, walkway'],
  ['gerpa', 'n. 1lun.', 'fruit, piece of fruit; the edible part of a plant'],
  ['gevie', 'adj. III', 'beautiful'],
  ['grevy', 'n. 2lun.', 'wheel'],
  ['haver', 'n. 6col.', 'loaf of bread'],
  ['haves', 'n. 4sol.', 'piece of bread'],
  ['havon', 'n. 3ter.', 'bread'],
  ['havor', 'n. 6col.3ter.', 'food; sustenance'],
  ['hubon', 'n. 3ter.', 'rope, cord'],
  ['hunes', 'n. 4sol', 'rabbit, hare, bunny'],
  ['hynga', 'n. 1lun', 'penis'],
  ['iemny', 'n. 2lun', 'stomach, belly of a human'],
  ['inkon', 'n. 3ter', 'back, back part, back side'],
  ['inkot', 'adv.', 'in back, to the back, backward'],
  ['iosre', 'adj. II', 'cold, cool'],
  ['izula', 'num. adj', 'four'],
  ['jagon', 'v. irreg.', 'to go'],
  ['jehar', 'n. 1aq.', 'emerald, malachite'],
  ['jenys', 'n. 2sol.', 'glass'],
  ['jenyr', 'n. 2sol.', 'glass'],
  ['jeson', 'n. 3ter.', 'dust, powder'],
  ['jevon', 'poss.pron. 3ter.', 'yours (pl.)'],
  ['kasta', 'adj. I', 'blue, green'],
  ['kempa', 'adj. I', 'heavy'],
  ['kesir', 'dem.pron. 5aq.', 'this one proximal, inanimate, for abstract or uncountable entitites, this place'],
  ['kessa', 'interj.', 'yes'],
  ['klios', 'n. 3sol', 'fish'],
  ['konir', 'dem.pron. 5aq.', 'that one distal, inanimate, for abstract or uncountable entities, that place'],
  ['konor', 'n. 3aq', 'steam, vapor'],
  ['korze', 'n. 4lun.', 'longsword, sword'],
  ['kynar', 'n. 1aq.', 'silk'],
  ['lanta', 'num. adj. I', 'two'],
  ['lanty', 'n. 2lun.', 'fox'],
  ['litse', 'adj. II', 'cute, pretty, fair, beautiful'],
  ['lopor', 'n. 3aq', 'salt'],
  ['lumie', 'adj. III', 'sick'],
  ['maegi', 'n. 5lun.', 'wise-woman, witch'],
  ['manda', 'adj. I', 'considerate, kind, courteous'],
  ['marta', 'adj. I', 'symmetrical, balanced'],
  ['massa', 'n. 1lun.', 'bat'],
  ['melvo', 'n. 3lun.', 'pear'],
  ['mhysa', 'n. 1lun.', 'mother'],
  ['mirre', 'adj. II', 'any'],
  ['molry', 'n. 2lun.', 'horn'],
  ['naena', 'num. n. 1lun.', 'many, multitude, horde'],
  ['nager', 'n. 3aq.', 'sweat'],
  ['nerny', 'n. 2lun.', 'door'],
  ['nopon', 'n. 3ter.', 'hole, pit'],
  ['obvos', 'n. 3sol.', 'arch'],
  ['olvie', 'adj. III', 'much, many'],
  ['olzon', 'n. 3ter.', 'amaranth'],
  ['ondor', 'n. 6col.3sol.', 'powers'],
  ['ondos', 'n. 3sol.', 'hand'],
  ['pelar', 'n. 1aq.', 'wave'],
  ['pirta', 'adj. III', 'false'],
  ['pogry', 'n. 2lun.', 'nail, claw'],
  ['pyrys', 'num. 2sol.', 'thousand'],
  ['qimos', 'n. 3sol.', 'chin'],
  ['qopsa', 'adj. I', 'rigid, stiff; difficult, hard (in the sense of difficult)'],
  ['raoba', 'n. 1lun.', 'turnip'],
  ['remio', 'n. 3lun.', 'gate'],
  ['rijes', 'n. 4sol.', 'praise, compliment'],
  ['ruaka', 'adj. I', 'dull; ineffective'],
  ['rytsa', 'adj. I', 'healthy'],
  ['sagon', 'v. irreg.', 'to be'],
  ['skore', 'int.pron. adj. II', 'which for inanimates, what'],
  ['somby', 'n. 2lun.', 'shield'],
  ['spare', 'int.pron. adj. II', 'which for animates'],
  ['taoba', 'n. 1lun.', 'boy'],
  ['tegon', 'n. 3ter.', 'ground, earth'],
  ['tegor', 'n. 3ter.', 'lands'],
  ['tegun', 'n. 6pauc.3ter.', 'land'],
  ['temby', 'n. 2lun.', 'leaf'],
  ['timpa', 'adj. I', 'white; light; light-colored; grey (light); pink'],
  ['tista', 'adj. I', 'dry'],
  ['tolie', 'adj. III', 'other'],
  ['tolys', 'indef.pron. 2sol.', 'someone else'],
  ['tubis', 'n. 5sol.', 'day'],
  ['ubles', 'n. 4sol.', 'eel'],
  ['udrin', 'n. 6pauc.5aq.', 'phrase, saying, aphorism'],
  ['udrir', 'n. 6col.5aq.', 'speech, language'],
  ['valar', 'nom. col. of vala', 'all men'],
  ['velma', 'n. 1lun.', 'father\'s older sister, paternal aunt older than father'],
  ['volpe', 'n. 4lun.', 'foresight'],
  ['yrgos', 'n. 3sol.', 'neck'],
  ['zokla', 'n. 1lun.', 'wolf'],
]
